import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./index.css";
import UserStore from "@/store/UserStore";
import BotsStore from "@/store/BotsStore";
var root = ReactDOM.createRoot(document.getElementById('root'));
export var Context = createContext(undefined);
root.render(_jsx(Context.Provider, { value: {
        user: new UserStore(),
        bots: new BotsStore()
    }, children: _jsx(App, {}) }));
